(() => {
  const input = document.querySelector('[data-faq-search]');
  if (!input) return;
  const categories = [...document.querySelectorAll('[data-faq-category]')];
  const status = document.querySelector('[data-faq-status]');
  const locale = document.documentElement.lang || 'en';
  const answerFound = input.dataset.answerFound || 'answer found';
  const answersFound = input.dataset.answersFound || 'answers found';
  const noAnswers = input.dataset.noAnswers || 'No answers found. Try another search term.';
  const normalize = value => value.toLocaleLowerCase(locale).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const search = () => {
    const query = normalize(input.value.trim());
    let count = 0;
    categories.forEach(category => {
      const categoryMatch = normalize(category.querySelector('h2')?.textContent || '').includes(query);
      let visible = 0;
      category.querySelectorAll('[data-faq-item]').forEach(item => {
        const matches = !query || categoryMatch || normalize(item.textContent).includes(query);
        item.hidden = !matches;
        if (matches) visible++;
      });
      category.hidden = visible === 0;
      category.closest('.shopify-section')?.toggleAttribute('hidden', visible === 0);
      count += visible;
    });
    if (status) { status.hidden = !query; status.textContent = count ? `${count} ${count === 1 ? answerFound : answersFound}` : noAnswers; }
  };
  document.querySelectorAll('.pl-faq-item').forEach(item => {
    const summary = item.querySelector('summary');
    summary.addEventListener('click', event => {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      event.preventDefault();
      const panel = item.querySelector('.pl-faq-item__panel');
      panel.getAnimations().forEach(animation => animation.cancel());
      if (item.open) {
        const height = panel.getBoundingClientRect().height;
        const animation = panel.animate([{ height: `${height}px`, opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'ease-in-out' });
        animation.onfinish = () => { item.open = false; panel.style.height = ''; };
      } else {
        item.open = true;
        const height = panel.scrollHeight;
        panel.animate([{ height: '0px', opacity: 0 }, { height: `${height}px`, opacity: 1 }], { duration: 300, easing: 'ease-out' });
      }
    });
  });
  input.addEventListener('input', search);
  document.addEventListener('shopify:section:load', search);
})();
